<template>
    <div class="dept_container">
        <div class="department_title">
            员工查询
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="输入查询：">
                <el-input
                    v-model="formInline.userName"
                    placeholder="请输入员工姓名或电话"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="所属职位" class="left_margin">
                <el-input
                    v-model="formInline.userPost"
                    placeholder="请输入职位"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item class="left_margin">
                <el-button type="primary" @click="onSubmit" class="inquire"
                >搜索
                </el-button
                >
                <el-button type="primary" class="reset" @click="reset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="big_box">
            <!-- 侧边树形结构   node-key="id"
                highlight-current
                :default-expanded-keys="[choiceId]" -->
            <div class="left_list">
                <el-tree
                    ref="tree"
                    accordion
                    node-key="id"
                    :default-expanded-keys="[100]"
                    :data="deptOptions"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                ></el-tree>
            </div>
            <div class="right_table">
                <div class="newly_built">
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        v-if="premission('system:user:add')"
                        @click="handleAdd"
                    >新建
                    </el-button
                    >
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="user_message_left">
                                <div class="userImg">
                                    <el-avatar
                                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                                    ></el-avatar>
                                </div>
                                <el-tag>在职中</el-tag>
                                <!-- <el-tag type="danger">已离职</el-tag> -->
                            </div>
                            <div class="user_message_cengter">
                                <div class="message_top">
                                    <span>姓名：{{ props.row.nickName }}</span>
                                    <span v-if="props.row.sex == 1">性别：男</span>
                                    <span v-else-if="props.row.sex == 2">性别：女</span>
                                    <span v-else>性别：未知</span>
                                    <span>身份证：{{ props.row.idCard }}</span>
                                </div>
                                <div class="message_center">
                                    <span>入职时间：{{ props.row.hiredate }}</span>
                                    <span
                                    >工作手机号：{{
                                            props.row.phonenumber || props.row.userPhone
                                        }}</span
                                    >

                                </div>

                                <div class="message_bottom">
                                     <span>  居住地址：{{ props.row.address }}</span>
                                    <span>工号：{{ props.row.workNo }}</span>
                                </div>

                            </div>
                            <div class="operate">
                                <el-button
                                    type="warning"
                                    size="small"
                                    @click="resetPasswordBtn(props.row)"
                                    v-if="premission('Reset:staffpassword')"
                                >重置
                                </el-button
                                >
                                <el-button
                                    type="primary"
                                    size="small"
                                    @click="compileBtn(props.row)"
                                    v-if="premission('system:user:edit')"
                                >编辑
                                </el-button
                                >
                                <!-- <el-button
                                  type="warning"
                                  size="small"
                                  v-if="props.row.status == 0"
                                  >禁用</el-button
                                >
                                <el-button
                                  type="success"
                                  size="small"
                                  v-if="props.row.status == 1"
                                  >启用</el-button
                                > -->
                                <el-button
                                    type="danger"
                                    size="small"
                                    @click="Delete(props.row)"
                                    v-if="premission('system:user:remove')"
                                >删除
                                </el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="员工姓名" prop="nickName"></el-table-column>
<!--                    <el-table-column label="员工编号" prop="userId"></el-table-column>-->
                    <el-table-column label="工号" prop="workNo"></el-table-column>
                    <el-table-column label="所属公司" prop="dept.company">
                    </el-table-column>
                    <el-table-column label="所属部门" prop="dept.deptName">
                    </el-table-column>
                    <el-table-column label="岗位" prop="userPost"></el-table-column>
                    <el-table-column label="业务手机号" prop="userPhone">
                    </el-table-column>
                    <el-table-column label="微信二维码">
                        <template slot-scope="scope">
                            <div class="QuickMark" @click="getImg(scope.row)">
                                <el-image
                                    style="width: 100%; height: 100%"
                                    :src="scope.row.avatar"
                                    :preview-src-list="srcList"
                                >
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 新增用户弹窗 -->
        <el-dialog
            :title="title"
            top="5vh"
            :visible.sync="dialogVisible"
            width="840px"
            @close="closeDialog"
        >
            <el-form
                ref="sizeForm"
                :model="sizeForm"
                label-width="160px"
                :rules="rules"
            >

                <el-form-item label="员工姓名：" prop="nickName">
                    <el-input
                        v-model="sizeForm.nickName"
                        placeholder="请输入员工姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="员工性别：">
                    <el-radio v-model="sizeForm.sex" label="1">男</el-radio>
                    <el-radio v-model="sizeForm.sex" label="2">女</el-radio>
                </el-form-item>
                <el-form-item label="工作手机号：" prop="phonenumber">
                    <el-input
                        v-model="sizeForm.phonenumber"
                        placeholder="请选择工作手机号"
                    ></el-input>
                </el-form-item>

                <el-form-item label="入职时间：" prop="hiredate">
                    <el-date-picker
                        v-model="sizeForm.hiredate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所在部门：" prop="deptId">
                    <el-input
                        v-model="sizeForm.deptId"
                        placeholder="添加部门"
                        readonly
                        @focus="AddDepartment"
                    ></el-input>
                </el-form-item>
                <el-form-item label="工号：" prop="workNo">
                    <el-input
                        v-model="sizeForm.workNo"
                        placeholder="请输入工号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="所在岗位：" prop="psot">
                    <el-input
                        v-model="sizeForm.psot"
                        placeholder="添加所在岗位，可多选"
                        readonly
                        @focus="AddPost"
                    ></el-input>
                </el-form-item>
                <el-form-item label="角色权限：" prop="roleName">
                    <el-input
                        v-model="sizeForm.roleName"
                        placeholder="添加角色"
                        readonly
                        @focus="AddRole"
                    ></el-input>
                </el-form-item>
                <el-form-item label="登录账户名：">
                    <el-input v-model="sizeForm.phonenumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="私人手机号：">
                    <el-input
                        v-model.trim="sizeForm.userPhone"
                        placeholder="请输入私人手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="微信二维码：" class="WeChat">
                    <el-upload
                        class="avatar-uploader"
                        action="/api/system/user/profile/wxCode"
                        :headers="headers"
                        name="avatarfile"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccessFour"
                        >
                        <img  v-if="sizeForm.avatar" :src="sizeForm.avatar" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
<!--                    <el-upload
                        :limit="1"
                        :headers="headers"
                        name="avatarfile"
                        :show-file-list="false"
                        :file-list="filelist"
                        action="/api/system/user/profile/wxCode"
                        list-type="picture-card"
                        :on-success="handleAvatarSuccessFour"
                        :on-remove="handleRemove"
                    >
                        <img style="width: 100%;height: 100%"
                             v-if="sizeForm.avatar" :src="sizeForm.avatar" class="avatar">
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>-->
<!--                    <el-dialog :visible.sync="dialogVisible_img">
                        <img width="100%" :src="dialogImageUrl" alt=""/>
                    </el-dialog>-->
                </el-form-item>
                <el-form-item label="常住地址：">
                    <el-input
                        v-model="sizeForm.address"
                        placeholder="请输入常驻地址"
                    ></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="idCard">
                    <el-input
                            v-model="sizeForm.idCard"
                        placeholder="请输入身份证号"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="add_new_btn_false('sizeForm')" class="cancel"
        >取 消</el-button
        >
        <el-button
            type="primary"
            @click="add_new_btn"
            class="add_new_btn"
            v-if="this.title == '添加员工'"
        >确 定</el-button
        >
        <el-button
            type="primary"
            @click="compile_btn"
            class="add_new_btn"
            v-if="this.title == '编辑员工'"
        >确 定</el-button
        >
      </span>
        </el-dialog>
        <!-- 分页 -->
        <div class="paging">
            <div class="block">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[8, 16, 24, 32]"
                    :page-size="8"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 弹出框新建岗位:before-close="handleClose" -->
        <el-dialog
            :title="addtitle"
            :visible.sync="AddPostVisible"
            width="640px"
            :show-close="false"
        >
            <!-- 部门 -->
            <div class="AddLabel" v-if="this.addtitleList == '选择部门'">
                <el-tag
                    :key="tag"
                    v-for="tag in dynamicTagsOne"
                    closable
                    type="warning"
                    :disable-transitions="false"
                    @close="handleCloseTagOne(tag)"
                >
                    {{ tag }}
                </el-tag>
            </div>
            <!-- 岗位 -->
            <div class="AddLabel" v-if="this.addtitleList == '选择岗位'">
                <el-tag
                    :key="tag"
                    v-for="tag in dynamicTagsTwo"
                    closable
                    type="warning"
                    :disable-transitions="false"
                    @close="handleCloseTagTwo(tag)"
                >
                    {{ tag }}
                </el-tag>
            </div>
            <!-- 角色 -->
            <div class="AddLabel" v-if="this.addtitleList == '选择角色'">
                <el-tag
                    :key="tag"
                    v-for="tag in dynamicTagsThree"
                    closable
                    type="warning"
                    :disable-transitions="false"
                    @close="handleCloseTagThree(tag)"
                >
                    {{ tag }}
                </el-tag>
            </div>
            <div class="select_list">
                <!-- 选择XX -->
                <div class="select_list_title">{{ addtitleList }}</div>
                <div class="select_list_tree">
                    <!-- 选择部门 -->
                    <el-tree
                        v-if="this.addtitleList == '选择部门'"
                        accordion
                        highlight-current
                        :data="deptOptions"
                        :props="defaultProps"
                        @node-click="handleNodeClickTwo"
                    ></el-tree>
                </div>
                <!-- 选择岗位 -->
                <el-checkbox-group
                    v-if="this.addtitleList == '选择岗位'"
                    v-model="checkListPost"
                    @change="handleCheckedCitiesChangePost"
                >
                    <el-checkbox
                        v-for="(item, index) in beforecheckListPost"
                        :label="item"
                        :key="index"
                    >
                        {{ item.postName }}
                    </el-checkbox>
                </el-checkbox-group>
                <!-- 选择角色 -->
                <el-checkbox-group
                    v-if="this.addtitleList == '选择角色'"
                    v-model="checkListUser"
                    @change="handleCheckedCitiesChangeUser"
                >
                    <el-checkbox
                        v-for="(item, index) in beforecheckListUser"
                        :label="item"
                        :key="index"
                    >
                        {{ item.roleName }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="AddPostVisibleCancel">取 消</el-button>
        <el-button type="primary" @click="AddPostVisibleOne">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 重置密码 -->
        <el-dialog
            title="重置密码"
            class="title_center"
            :visible.sync="resetVisible"
            width="600px"
            :show-close="false"
        >
            <div class="resetPassText">
                是否将账号密码重置为初始密码（初始密码为'12345678'）
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" class="cancel">取 消</el-button>
                <el-button type="primary" @click="resetUser" class="success_Btn"
                >确 定
                </el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
// import { handleTree } from "../../utils/treating";
import {
    updateUser,
    AddUserListsAjax,
    getUser,
    UserListsAjax,
    UserListZw,
    TreeselectListsAjax,
    UserDeleteAjax,
    resetUserPwd
} from "../../api/index";
// import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import premission from "../../utils/permission";
import {Debounce} from "@/utils/treating";

export default {
    // components: { Treeselect },
    mixins: [premission],
    data() {
        var phonenumber = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("手机号码不能为空"));
            } else if (!/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
                callback(new Error("手机号码格式错误!"));
            } else {
                callback();
            }
        };
        var isUserName = (rule, value, callback) => {
            var regPos =  /^\d*$/;
            if (value === "") {
                callback(new Error("用户名不能为空"));
            } else if (regPos.test(value)) {
                callback(new Error("不能输入数字!"));
            } else {
                callback();
            }
        };

        var deptId = (rule, value, callback) => {
            if (value === undefined) {
                callback(new Error("所在部门不能为空"));
            } else {
                callback();
            }
        };
        var psot = (rule, value, callback) => {
            if (value === undefined) {
                callback(new Error("所在岗位不能为空"));
            } else {
                callback();
            }
        };
        var roleName = (rule, value, callback) => {
            if (value === undefined) {
                callback(new Error("角色权限不能为空"));
            } else {
                callback();
            }
        };

        return {
            // 表单校验
            rules: {
                nickName:[
                    {validator: isUserName, required: true, trigger: "blur"}
                ],
                userName: [
                    {required: true, message: "登录账户名不能为空", trigger: "blur"},
                    {min: 2, max: 10, message: "长度在 2 到 8 个字符", trigger: "blur"}

                ],
                phonenumber: [{validator: phonenumber, required: true, trigger: "blur"}],
                hiredate: [
                    {required: true, message: "入职时间不能为空", trigger: "blur"}
                ],
                idCard:[
                    {required: true, message: "身份证号不能为空", trigger: "blur"}
                ],
                deptId:[
                    {required: true, message: "所在部门不能为空", trigger: "change"}
                ],
                workNo:[
                    {required: true, message: "工号不能为空", trigger: "blur"}
                ],
                psot:[
                    {required: true, message: "所在岗位不能为空", trigger: "change"}
                ],
                roleName:[
                    {required: true, message: "角色权限不能为空", trigger: "change"}
                ],
            },
            filelist:[],//头像数组
            // 节流阀
            // handleAvatarSuccess: [],
            throttle: "true",
            // choiceId: "146",
            customerId: "",
            // 岗位多选前
            beforecheckListPost: [],
            // 角色多选前
            beforecheckListUser: [],
            // 岗位多选后数据
            checkListPost: [],
            checkListPostList: [],
            // 角色多选后数据
            checkListUser: [],
            checkListUserList: [],
            // 树形结构数据集合
            inputValueList: "",
            // 树形结构获取的数据
            inputValue: "",
            // Tag数据
            dynamicTagsOne: [],
            dynamicTagsTwo: [],
            dynamicTagsThree: [],

            // 弹出框-弹出目录名
            addtitle: "",
            // 弹出框-弹出目录名子菜单
            addtitleList: "",
            // 分页
            total: 0,
            currentPage: 1,
            // 新建公司弹窗
            resetVisible: false,
            dialogVisible: false,
            AddPostVisible: false,
            //是否显示
            switch_value: false,
            // 搜索数据
            formInline: {
                pageNum: 1,
                pageSize: 8,
                userName: "",
                userPost: ""
            },
            // 新建公司数据
            sizeForm: {
                userName:'',
                nickName:'',
                userId: "", //用户名称
                sex: "1",
                phonenumber: "", //工作手机号
                hiredate: "", //入职时间
                deptId: "", //部门
                psot: undefined, //岗位
                roleName: "", //角色
                loginName: '',//sessionStorage.getItem("userName") || "", //登录人
                userPhone: "", //用户手机号
                avatar: "", //微信二维码
                address: "", //居住地址
                idCard: "", //身份证号码
                workNo: '' // 工号
            },
            id: "",
            // 表单数据1
            tableData: [],
            defaultProps: {
                children: "children",
                label: "label"
            },
            img:
                "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",

            // 查看大图
            srcList: [],
            // 部门树选项
            deptOptions: [],
            // 弹出层标题
            title: "",
            // 上传图片
            dialogImageUrl: "",
            dialogVisible_img: false
        };
    },
    computed: {
        headers() {
            return {
                Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
            };
        }
    },
    created() {
        this.getUserListsAjax();
        this.getTreeselectListsAjax();
        // this.$nextTick(() => {
        //   this.$refs.tree.setCurrentKey(this.choiceId);
        // });
    },
    methods: {
        closeDialog(){
          //关闭弹窗回调
            this.filelist = [];
            this.checkListPost = [];
            this.checkListPostList = [];
            this.checkListUser = [];
            this.checkListUserList = []
            this.add_new_btn_false('sizeForm')
        },
        //员工查询 - 搜索
        onSubmit: Debounce(async function () {
            var obj = {...this.formInline};
            var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

            if (obj.userName !== '' || !obj.userPost) {
                //姓名和电话不为空职位为空
                delete obj.userPost;
                if (reg_tel.test(obj.userName)) {
                    obj.phonenumber = obj.userName;
                    delete obj.userName;
                }
                const {data: res} = await UserListsAjax(obj);
                if (res.code !== 200)
                    return this.$message.error(res.msg)
                this.tableData = res.rows;
                this.total = res.total;
            } else {
                //只输入职位时
                const {data: res} = await UserListZw(obj);
                if (res.code !== 200)
                    return this.$message.error(res.msg)
                this.tableData = res.rows;
                this.total = res.total;
            }

        }, 500),
        // 重置
        reset() {
            this.formInline = {
                pageNum: 1,
                pageSize: 8,
                userName: "",
                userPost: ""
            }
            this.onSubmit();
        },
        /** 转换部门数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.deptId,
                label: node.deptName,
                children: node.children
            };
        },
        // 获取表单数据
        async getUserListsAjax() {
            const {data: res} = await UserListsAjax(this.formInline);
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.tableData = res.rows;
            this.total = res.total;
        },
        //获取树形结构数据
        async getTreeselectListsAjax() {
            const {data: res} = await TreeselectListsAjax();
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.deptOptions = res.data;
        },
        // 新增按钮操作
        handleAdd() {
            this.dialogVisible = true;
            this.title = "添加员工";
            this.getUserAjax();
        },
        async getUserAjax() {
            const {data: res} = await getUser();
            if (res.code !== 200)
                return this.$message({
                    type: "error",
                    message: res.msg
                });
            this.beforecheckListPost = res.posts;
            this.beforecheckListUser = res.roles;
        },
        // 编辑按钮
        async compileBtn(e) {
            this.dialogVisible = true;
            const {data: res} = await getUser(e.userId);
            if (res.code !== 200)
                return this.$message({
                    type: "error",
                    message: res.msg
                });
            this.sizeForm.userName = res.data.userName;
           this.sizeForm.nickName = res.data.nickName;
            this.sizeForm.sex = res.data.sex;
            this.sizeForm.phonenumber = res.data.phonenumber;
            this.sizeForm.hiredate = res.data.hiredate;
            this.sizeForm.deptId = res.data.userDept;
            this.sizeForm.psot = res.postNames.toString();
            this.sizeForm.roleName = res.roleNames.toString();
            this.sizeForm.userPhone = res.data.userPhone;
            this.sizeForm.address = res.data.address;
            this.sizeForm.idCard = res.data.idCard;
            this.beforecheckListPost = res.posts;
            this.beforecheckListUser = res.roles;
            this.checkListPostList = res.postIds;
            this.checkListUserList = res.roleIds;
            this.id = res.data.userId;
            this.sizeForm.avatar=res.data.avatar
            this.sizeForm.workNo=res.data.workNo
            this.title = "编辑员工";
            // this.handleAvatarSuccess = res.data
        },
        // 编辑时的确定按钮
        async compile_btn() {
            console.log('编辑',this.throttle)
            if (!this.throttle) return;
            this.throttle = false;
            console.log("修改")
            this.$refs.sizeForm.validate(async valid => {
                if (valid) {
                    const {data: res} = await updateUser({
                        userName: this.sizeForm.nickName,
                        sex: this.sizeForm.sex,
                        // password: "12345678",
                        phonenumber: this.sizeForm.phonenumber,
                        hiredate: this.sizeForm.hiredate,
                        deptId: this.inputValueList.id,
                        postIds: this.checkListPostList,
                        roleIds: this.checkListUserList,
                        nickName: this.sizeForm.nickName,
                        userPhone: this.sizeForm.userPhone,
                        avatar: this.sizeForm.avatar, //微信二维码
                        address: this.sizeForm.address,
                        idCard: this.sizeForm.Usernumber||this.sizeForm.idCard,
                        userId: this.id,
                        workNo:this.sizeForm.workNo
                    });
                    if (res.code !== 200) {
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });
                    } else {
                        this.throttle = true;
                        this.sizeForm = {
                            userId: "", //用户名称
                            userName:'',
                            sex: "1",
                            phonenumber: "", //用户手机号
                            hiredate: "", //入职时间
                            deptId: "", //部门
                            psot: "", //岗位
                            roleName: "", //角色
                            loginName: sessionStorage.getItem("userName") || "", //登录人
                            userPhone: '',
                            avatar: '', //微信二维码
                            address: "", //居住地址
                            idCard: "", //身份证号码
                            workNo:''
                        };
                        this.checkListPostList = "";
                        this.checkListUserList = "";
                        this.inputValueList = "";
                        this.getUserListsAjax();
                        this.beforecheckListPost = [];
                        // 角色多选前
                        this.beforecheckListUser = [];
                        // 岗位多选后数据
                        this.checkListPost = [];
                        this.checkListPostList = [];
                        // 角色多选后数据
                        this.checkListUser = [];
                        this.checkListUserList = [];
                        this.dialogVisible = false;
                        return this.$message({
                            type: "success",
                            message: "编辑员工成功"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        getImg(row) {
            this.srcList = [];
            this.srcList.push(row.avatar);
        },
        // 新建用户
        async add_new_btn() {
            this.$refs.sizeForm.validate(async valid => {
                if (valid) {
                    const {data: res} = await AddUserListsAjax({
                        userName: this.sizeForm.nickName||this.sizeForm.phonenumber,//员工账号
                        sex: this.sizeForm.sex,//性别
                        password: "12345678",//密码
                        phonenumber: this.sizeForm.phonenumber,//手机号
                        hiredate: this.sizeForm.hiredate,
                        deptId: this.inputValueList.id,
                        postIds: this.checkListPostList,
                        roleIds: this.checkListUserList,
                        nickName: this.sizeForm.nickName,
                        userPhone: this.sizeForm.userPhone,//工作手机号
                        avatar: this.sizeForm.avatar, //微信二维码
                        address: this.sizeForm.address,//住址
                        idCard: this.sizeForm.idCard,
                        workNo:this.sizeForm.workNo
                    });
                    if (res.code !== 200) {
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });
                    } else {
                        this.throttle = true;
                      /*  this.sizeForm = {
                            userId: "", //用户名称
                            sex: "1",
                            phonenumber: "", //用户手机号
                            inputTime: "", //入职时间
                            deptId: "", //部门
                            psot: "", //岗位
                            roleName: "", //角色
                            loginName: sessionStorage.getItem("userName") || "", //登录人
                            WorkTel: "", //工作手机号
                            WeChat: "", //微信二维码
                            site: "", //居住地址
                            idCard: "" //身份证号码
                        };
                        this.dynamicTagsOne = [];
                        this.dynamicTagsTwo = [];
                        this.dynamicTagsThree = [];
                        this.checkListPostList = "";
                        this.checkListUserList = "";
                        this.inputValueList = "";*/
                        this.add_new_btn_false('sizeForm')
                        this.getUserListsAjax();
                        this.dialogVisible = false;
                        return this.$message({
                            type: "success",
                            message: "新增员工成功"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 新建公司弹窗确认和取消
        handleClose(done) {
            this.$confirm("确认关闭？")
                .then(_ => {
                    done();
                    this.sizeForm = {
                        userId: "", //用户名称
                        sex: "1",
                        phonenumber: "", //用户手机号
                        hiredate: "", //入职时间
                        deptId: "", //部门
                        psot: "", //岗位
                        roleName: "", //角色
                        loginName: sessionStorage.getItem("userName") || "", //登录人
                        userPhone: this.sizeForm.userPhone,
                        avatar: this.sizeForm.WeChat, //微信二维码
                        address: "", //居住地址
                        idCard: "" //身份证号码
                    };
                    this.checkListPostList = "";
                    this.checkListUserList = "";
                    this.inputValueList = "";
                    this.dynamicTagsOne = [];
                    this.dynamicTagsTwo = [];
                    this.dynamicTagsThree = [];
                })
                .catch(_ => {
                });
        },
        // 删除部门
        Delete(e) {
            this.open(e);
        },
        open(e) {
            this.$confirm(`是否确认删除名称为"${e.userName}"的数据项？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    const {data: res} = await UserDeleteAjax(e.userId);
                    if (res.code !== 200)
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });
                    this.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                    this.getUserListsAjax();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },

        // 筛选节点
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        // 节点单击事件
        handleNodeClick(data) {
            this.formInline.deptId = data.id;
            this.onSubmit();
        },
        // 弹出框新建岗位
        AddPost() {
            this.AddPostVisible = true;
            this.addtitle = "添加岗位";
            this.addtitleList = "选择岗位";
        },
        // 弹出框新建部门
        AddDepartment() {
            this.AddPostVisible = true;
            this.addtitle = "添加部门";
            this.addtitleList = "选择部门";
        },
        // 弹出框新建角色权限
        AddRole() {
            this.AddPostVisible = true;
            this.addtitle = "添加角色";
            this.addtitleList = "选择角色";
        },
        // 上传图片按钮
        handleRemove(file, fileList) {
            this.filelist=[];
            this.sizeForm.avatar=''
            console.log(file, fileList);
        },
        handleAvatarSuccessFour(response) {
            console.log(response)
            this.sizeForm.avatar = response.msg;
        },
        // 分页
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.onSubmit();
        },
        handleCurrentChange(val) {
            this.formInline.pageNum = val;
            this.onSubmit();
        },
        // 新增树形
        handleNodeClickTwo(data) {
            this.inputValueList = data;
            this.inputValue = data.label;
            this.handleInputConfirm();
        },
        // Tag删除标签
        handleCloseTagOne(tag) {
            this.dynamicTagsOne.splice(this.dynamicTagsOne.indexOf(tag), 1);
        },
        handleCloseTagTwo(tag) {
            this.dynamicTagsTwo.splice(this.dynamicTagsTwo.indexOf(tag), 1);
            this.sizeForm.psot = this.dynamicTagsTwo.toString();
            for (var k in this.checkListPost) {
                if (this.dynamicTagsTwo.indexOf(this.checkListPost[k].postName) == -1) {
                    this.checkListPost.splice(k, 1);
                    return;
                }
            }
        },
        handleCloseTagThree(tag) {
            this.dynamicTagsThree.splice(this.dynamicTagsThree.indexOf(tag), 1);
            this.sizeForm.roleName = this.dynamicTagsThree.toString();
            for (var k in this.checkListUser) {
                if (
                    this.dynamicTagsThree.indexOf(this.checkListUser[k].postName) == -1
                ) {
                    this.checkListUser.splice(k, 1);
                    return;
                }
            }
        },

        // Tag新增数据
        handleInputConfirm() {
            if (this.addtitleList == "选择部门") {
                var inputValue = this.inputValue;
                if (inputValue) {
                    if (this.dynamicTagsOne.indexOf(this.inputValue) != -1) return;
                    if (!this.inputValueList.children) {
                        this.dynamicTagsOne = [];
                        this.dynamicTagsOne.push(inputValue);
                    }
                }
            }
            this.sizeForm.deptId = this.inputValue;
        },
        // 确认按钮
        AddPostVisibleOne() {
            if (this.dynamicTagsOne.length == 0) {
                this.inputValue = "";
                this.sizeForm.deptId = this.inputValue;
            }
            this.AddPostVisible = false;
        },
        // 取消按钮
        AddPostVisibleCancel() {
            this.AddPostVisible = false;
            if (this.sizeForm.deptId) {
                if (this.dynamicTagsOne.indexOf(this.sizeForm.deptId) == -1) {
                    this.dynamicTagsOne.push(this.sizeForm.deptId);
                }
            }
        },
        // 岗位多选框
        handleCheckedCitiesChangePost(e) {
            this.dynamicTagsTwo = e.map(item => {
                return item.postName;
            });
            this.checkListPostList = this.checkListPost.map(item => {
                return item.postId;
            });
            this.sizeForm.psot = this.dynamicTagsTwo.toString();
        },
        //角色多选框
        handleCheckedCitiesChangeUser(e) {
            this.dynamicTagsThree = e.map(item => {
                return item.roleName;
            });
            this.checkListUserList = this.checkListUser.map(item => {
                return item.roleId;
            });
            this.sizeForm.roleName = this.dynamicTagsThree.toString();
        },
        add_new_btn_false(sizeForm) {
            this.sizeForm = {
                userId: "", //用户名称
                userName:'',
                sex: "1",
                phonenumber: "", //用户手机号
                hiredate: "", //入职时间
                deptId: "", //部门
                psot: "", //岗位
                roleName: "", //角色
                loginName: sessionStorage.getItem("userName") || "", //登录人
                userPhone: "", //工作手机号
                avatar: "", //微信二维码
                address: "", //居住地址
                idCard: "" //身份证号码
            };
            this.checkListPostList = "";
            this.checkListUserList = "";
            this.inputValueList = "";
            this.dynamicTagsOne = [];
            this.dynamicTagsTwo = [];
            this.dynamicTagsThree = [];
            this.dialogVisible = false;
            this.checkListPost=[]
            this.$refs[sizeForm].resetFields();
        },
        // 重置密码
        resetPasswordBtn(e) {
            console.log(e);
            this.resetVisible = true;
            this.customerId = e.userId;
        },
        // 重置密码
        async resetUser() {
            const {data: res} = await resetUserPwd(this.customerId, "12345678");
            if (res.code !== 200) {
                return this.$message({
                    type: "error",
                    message: res.msg
                });
            } else {
                this.resetVisible = false;
                this.getUserListsAjax();
                return this.$message({
                    type: "success",
                    message: res.msg
                });
            }
        },
        cancel() {
            this.resetVisible = false;
        }
    }
};
</script>

<style lang="less" scoped>
.department_title {
    width: 72px;
    height: 24px;
    font-size: 18px;
    line-height: 24px;
    color: #171a1e;
    margin-bottom: 20px;
}

/deep/ .demo-form-inline {
    .el-input__inner {
        width: 200px;
        height: 36px;
        font-size: 14px;
    }

    .left_margin {
        margin-left: 26px;
    }
}

.newly_built {
    margin-top: 18px;
    margin-bottom: 20px;
}

.operation_right {
    margin-right: 20px;
}

.el-form-item--mini.el-form-item {
    margin-bottom: 24px;
    height: 36px;

    /deep/ .el-form-item__content {
        height: 36px;

        .el-input--mini {
            height: 36px;

            input {
                height: 36px;
            }
        }
    }
}

.el-form-item--mini.el-form-item.WeChat {
    height: 120px;
}

/deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
    height: 120px;
    width: 120px;
}

/deep/ .el-table th {
    font-family: Microsoft YaHei;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    background-color: #f2f2f2;
}

/deep/ .el-table__row td {
    text-align: center;
    height: 60px;
    padding: 4px 0;
}

// /deep/ .el-table td {
//   padding: 4px 0;
// }

.dialog-footer {
    .add_new_btn {
        margin-left: 24px;
        background-color: #f6b439;
        border: 1px solid #f6b439;
    }

    .cancel {
        background: #f2f2f2;
        border: 1px solid #e1e1e1;
    }
}

/deep/ .el-dialog__header {
    .el-dialog__title {
        font-weight: normal;
    }
}

/deep/ .el-form-item--mini .el-form-item__label {
    font-weight: normal;
    font-size: 16px;
}

/deep/ .el-dialog {
    border-radius: 10px;
    padding: 30px 30px;

    .el-dialog__header {
        padding-top: 0;
    }

    .el-dialog__body {
        padding-top: 30px;
    }

    .el-dialog__headerbtn {
        top: 36px;
    }

    .el-date-editor.el-input {
        width: 100%;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #000;
    }
}

/deep/ .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 36px;
    font-size: 16px;
}

.big_box {
    overflow: hidden;

    .left_list {
        margin-top: 20px;
        padding: 20px 0 20px 0;
        float: left;
        width: 240px;
    }

    .right_table {
        float: left;
        width: 80%;

        padding-left: 30px;
        border-left: 1px solid #ccc;
    }
}

.el-image {
    line-height: 48px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.QuickMark {
    margin-left: 80px;
    width: 48px;
    height: 48px;
}

/deep/ .el-table__expanded-cell {
    padding: 10px 0 10px 78px;
}

.el-avatar {
    width: 60px;
    height: 60px;
}

.user_message_left {
    width: 60px;
    float: left;

    .userImg {
        height: 72px;
    }
}

.user_message_cengter {
    float: left;
    color: #000;
    font-size: 14px;
    margin-left: 24px;

    .message_top {
        span {
            margin-right: 50px;
        }
    }

    .message_center {
        margin: 18px 0;

        span {
            margin-right: 50px;
        }
    }

    .message_bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            display: block;
            width: calc(100% / 2 - 20px);
            height: 30px;
            overflow: hidden;
            margin-right: 50px;
            white-space:nowrap;
            text-overflow:ellipsis;
            -o-text-overflow:ellipsis;
            overflow:hidden;
        }
    }
}

.operate {
    float: right;

    .el-button--warning {
        background-color: #f6b439;
        border-color: #f6b439;
    }

    .el-button--success {
        background-color: #219653;
        border-color: #219653;
    }
}

/deep/ .el-table__body .expanded {
    background-color: #e7f0ff;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f6b439;
}

/deep/ .el-pagination .el-select .el-input .el-input__inner {
    color: #999999;
}

/deep/ .el-table__header-wrapper {
    height: 50px;
}

/deep/ .el-table__header {
    height: 50px;
}

.paging {
    margin-top: 40px;
    margin-left: 610px;
}

.el-dialog__footer {
    button {
        text-align: center;
        line-height: 13px;
        width: 72px;
        height: 36px;
    }
}

.AddLabel {
    // width: 580px;
    min-height: 42px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin-bottom: 24px;

    .el-tag.el-tag--warning {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }
}

.select_list {
    padding: 20px;
    // width: 580px;
    min-height: 450px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin: 0;

    .el-checkbox {
        margin-bottom: 30px;
        width: 85px;
        margin-right: 40px;
    }
}

.select_list_title {
    margin-bottom: 20px;
}

.select_list_tree {
    width: 240px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #f6b439;
    background: #f6b439;
    width: 24px;
    height: 24px;
}

/deep/ .el-radio__label {
    font-size: 16px;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #f6b439;
}

/deep/ .el-radio__inner {
    width: 24px;
    height: 24px;
}

/deep/ .el-radio__inner::after {
    width: 10px;
    height: 10px;
}

/deep/ .el-tree--highlight-current
.el-tree-node.is-current
> .el-tree-node__content {
    background-color: #409eff;
    color: white;
}
/deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
/deep/ .avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
